import React, { useEffect } from "react";
import { FaSpinner } from "react-icons/fa";

const FullScreenLoader = ({ show }) => {
  // Disable scroll when loader is active
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 bg-transparent flex items-center justify-center z-[9999]"
      style={{ pointerEvents: "auto" }} // blocks all interactions
    >
      <FaSpinner className="text-5xl text-blue-600 animate-spin" />
    </div>
  );
};

export default FullScreenLoader;
